var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"9","viewBox":"0 0 12 9","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M10.59 0.794922L6 5.37492L1.41 0.794922L0 2.20492L6 8.20492L12 2.20492L10.59 0.794922Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }